import { Trans, useTranslation } from 'react-i18next'

import { Button, Checkbox } from '@reveni-io/reveni-ui'

import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import {
  canTransactionsBeAcceptedOrRejected,
  hasJustOnHoldTransactions,
  shouldShowNoAvailableActionsLabel,
} from './helpers'
import * as Styles from './styles'

const CheckAllTransactions = ({
  selectedOrders,
  orders,
  onCheckAllOrder,
  onAcceptSelected,
  onRejectSelected,
  onApproveSelected,
  onDeclineSelected,
}) => {
  const { hasPermission } = useUserPermissions()
  const { t } = useTranslation()

  const selectableTransactionsCount = orders?.filter(order => order?.available_status?.length).length

  const getSelectedOrdersLabel = () => {
    if (shouldShowNoAvailableActionsLabel({ orders, selectedOrders, selectableTransactionsCount, hasPermission })) {
      return t('No hay acciones disponibles para esta selección')
    }

    if (selectedOrders?.length === 1) {
      return `${selectedOrders?.length} ${t('Transacción seleccionada')}`
    }
    return `${selectedOrders?.length} ${t('Transacciones seleccionadas')}`
  }

  if (!orders?.length) {
    return null
  }

  return (
    <Styles.CheckAllContainer>
      <Checkbox
        checked={selectedOrders?.length > 0 && selectedOrders?.length === selectableTransactionsCount}
        onChange={onCheckAllOrder}
        indeterminate={selectedOrders?.length > 0 && selectedOrders?.length < orders?.length}
        label={getSelectedOrdersLabel()}
        disabled={!selectableTransactionsCount}
      />
      {canTransactionsBeAcceptedOrRejected({ orders, selectedOrders, hasPermission }) && (
        <Styles.AcceptRejectButtons>
          <Button color="success" onClick={onAcceptSelected}>
            <Trans i18nKey="acceptAllProducts">Aceptar productos</Trans>
          </Button>
          <Button color="danger" onClick={onRejectSelected}>
            <Trans i18nKey="rejectAllProducts">Rechazar productos</Trans>
          </Button>
        </Styles.AcceptRejectButtons>
      )}
      {hasJustOnHoldTransactions({ orders, selectedOrders, hasPermission }) && (
        <Styles.AcceptRejectButtons>
          <Button color="success" onClick={onApproveSelected}>
            {t('Aprobar solicitudes')}
          </Button>
          <Button color="danger" onClick={onDeclineSelected}>
            {t('Rechazar solicitudes')}
          </Button>
        </Styles.AcceptRejectButtons>
      )}
    </Styles.CheckAllContainer>
  )
}

export default CheckAllTransactions
